import { PAPER_NOISE } from './paperNoise'
import { cx } from './cx'
import styles from './DecorativeDocumentSheet.module.scss'

export type DecorativeDocumentSheetProps = {
    title: string
    /** Sizing/positioning classes — paper styling stays fixed. */
    className?: string
}

const paragraphOne = [100, 100, 100, 62]
const paragraphTwo = [100, 100, 88]

/**
 * Decorative miniature legal-document sheet for the bottom-right of a
 * DocumentPreviewCard (cloned from sentinel-web form-ui retainer cards).
 */
export const DecorativeDocumentSheet = ({ title, className }: DecorativeDocumentSheetProps) => (
    <div aria-hidden="true" className={cx(styles.root, className ?? styles.defaultPosition)}>
        <div className={styles.paperBase} />
        <div className={styles.paperShade} />
        <div className={styles.paperNoise} style={{ backgroundImage: PAPER_NOISE }} />

        <div className={styles.content}>
            <p className={styles.title}>{title}</p>

            <div className={styles.rule} />
            <div className={styles.ruleSoft} />

            <div className={styles.paragraph}>
                {paragraphOne.map((width, index) => (
                    <div key={`p1-${index}`} className={styles.line} style={{ width: `${width}%` }} />
                ))}
            </div>
            <div className={styles.paragraph}>
                {paragraphTwo.map((width, index) => (
                    <div key={`p2-${index}`} className={styles.line} style={{ width: `${width}%` }} />
                ))}
            </div>

            <div className={styles.footer}>
                <div className={styles.signatureRow}>
                    <span className={styles.signatureMark}>x</span>
                    <div className={styles.signatureLine} />
                </div>
                <div className={styles.labels}>
                    <span>Signature</span>
                    <span>Date</span>
                </div>
            </div>
        </div>
    </div>
)
